import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/smackback/blue_bg.webp";

function Purpose() {
  return (
    <section
      className="purpose_section p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2>The Purpose of the App</h2>
            <p>
              Sending and receiving text messages is one of the most essential
              activities people perform using their cellphones. The primary
              purpose of Smackback is to provide convenience and eliminate the
              mundane task of responding to text messages from people’s to-dos.
              Stay connected and efficient, through an automated system which
              can shoot customized and/or pre-defined messages to contacts With
              Smackback, you can invest time on things that really count without
              compromising your personal connections.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/smackback/right.webp"
              alt="smackback TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={570}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Purpose;
